var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M170.667,423.721H8.828c-4.875,0-8.828-3.953-8.828-8.828V97.101c0-4.875,3.953-8.828,8.828-8.828  h161.839V423.721z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 88.277,
    style: {
      fill: "#FFE15A"
    },
    width: 170.67,
    height: 335.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M503.172,423.721H341.333V88.273h161.839c4.875,0,8.828,3.953,8.828,8.828v317.792  C512,419.769,508.047,423.721,503.172,423.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCBE82"
    },
    d: "M316.022,284.688c0-2.562-2.077-4.64-4.64-4.64c-0.556,0-1.082,0.114-1.577,0.294  c-2.296-2.042-6.457-7.109-2.282-14.264c0.564,0.439,1.265,0.711,2.035,0.711c1.841,0,3.332-1.492,3.332-3.332  c0-1.454-0.937-2.678-2.236-3.133c3.431-1.75,8.324-5.465,8.072-12.412c-0.359-9.852-8.429-15.29-13.38-13.116  c0.018-0.138,0.042-0.274,0.042-0.416c0-1.815-1.471-3.286-3.286-3.286c-1.116,0-2.098,0.559-2.691,1.409  c-0.202-0.985-0.178-2.814,2.112-4.791c4.253-3.673,9.086-12.469,0.29-18.655c-4.871-3.425-14.181-5.066-17.301-0.386  c-1.353,2.029-0.268,4.945,1.277,5.6c-2.489,1.388-7.211,3.471-10.942,1.843c-5.316-2.319-2.246-6.926-1.063-8.989  c2.078-3.625,0.774-9.569-6.186-9.569c-4.64,0-6.959,4.64-11.598,4.64c-4.639,0-6.959-4.64-11.598-4.64  c-6.959,0-8.264,5.944-6.186,9.569c1.183,2.062,4.253,6.669-1.063,8.989c-3.731,1.629-8.452-0.455-10.942-1.843  c1.544-0.654,2.63-3.57,1.277-5.6c-3.119-4.679-12.43-3.039-17.301,0.386c-8.796,6.186-3.962,14.981,0.29,18.655  c2.29,1.977,2.314,3.807,2.112,4.791c-0.594-0.85-1.576-1.409-2.691-1.409c-1.815,0-3.286,1.471-3.286,3.286  c0,0.142,0.024,0.279,0.042,0.416c-4.951-2.175-13.022,3.264-13.38,13.116c-0.253,6.946,4.641,10.661,8.072,12.412  c-1.299,0.456-2.236,1.679-2.236,3.133c0,1.841,1.492,3.332,3.332,3.332c0.77,0,1.47-0.271,2.035-0.711  c4.175,7.155,0.015,12.222-2.282,14.264c-0.494-0.18-1.021-0.294-1.577-0.294c-2.562,0-4.64,2.077-4.64,4.64  c0,2.405,1.837,4.36,4.182,4.594c-3.198,3.285-6.067,10.525,0.168,18.749c6.814,8.989,23.052,8.264,30.881,8.554  c4.964,0.184,8.698,2.754,10.771,4.613c-1.325,0.817-2.217,2.269-2.217,3.94c0,2.343,1.743,4.26,4,4.575  c0.82,1.312,2.265,2.191,3.926,2.191c1.856,0,3.445-1.097,4.188-2.673c2.45,2.019,4.125,2.866,4.125,2.866s1.675-0.846,4.125-2.866  c0.742,1.575,2.332,2.673,4.188,2.673c1.661,0,3.106-0.879,3.926-2.191c2.257-0.315,4-2.232,4-4.575c0-1.672-0.892-3.124-2.217-3.94  c2.072-1.859,5.806-4.43,10.771-4.613c7.829-0.29,24.067,0.435,30.881-8.554c6.234-8.224,3.366-15.465,0.168-18.749  C314.185,289.047,316.022,287.093,316.022,284.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2AA73"
    },
    d: "M214.245,225.099v67.273c0,7.687,6.231,13.919,13.919,13.919h18.558c6.959,0,9.279,4.64,9.279,4.64  s2.319-4.64,9.279-4.64h18.558c7.687,0,13.919-6.231,13.919-13.919v-67.273c0-1.281-1.038-2.319-2.319-2.319h-78.871  C215.283,222.78,214.245,223.818,214.245,225.099z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.88,
    y: 227.417,
    style: {
      fill: "#FF4B55"
    },
    width: 34.796,
    height: 34.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M253.68,301.651L253.68,301.651c-19.218,0-34.796-15.578-34.796-34.796l0,0h34.796V301.651z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M258.32,301.651L258.32,301.651v-34.796h34.796l0,0C293.115,286.071,277.536,301.651,258.32,301.651   z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.32,
    y: 227.417,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  })), /*#__PURE__*/React.createElement("rect", {
    x: 263.29,
    y: 227.417,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.26,
    y: 227.417,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.24,
    y: 227.417,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.2,
    y: 227.417,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.14,
    y: 227.417,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.18,
    y: 227.417,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.48,
    y: 266.857,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.35,
    y: 266.857,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.09,
    y: 266.857,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  })), /*#__PURE__*/React.createElement("rect", {
    x: 238.21,
    y: 266.857,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.81,
    y: 266.857,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.95,
    y: 266.857,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M222.75,299.881v-33.026h-3.866v25.517C218.884,295.469,220.417,298.195,222.75,299.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M226.617,301.495v-34.641h-3.866v33.026C223.877,300.694,225.188,301.254,226.617,301.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M226.617,266.855v34.641c0.505,0.085,1.016,0.156,1.547,0.156h2.319v-34.796h-3.866V266.855z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M224.07,260.24c-0.173,0-0.348-0.049-0.503-0.151c-2.281-1.51-2.414-3.082-2.29-3.884   c0.167-1.084,0.973-1.983,2.054-2.292c1.028-0.289,2.053,0.014,2.746,0.819c1.44,1.674,2.927,2.333,4.179,1.87   c0.991-0.367,1.582-1.344,1.582-2.074c0-0.505,0.408-0.914,0.914-0.914s0.914,0.408,0.914,0.914c0,1.598-1.166,3.191-2.774,3.787   c-1.175,0.434-3.538,0.702-6.2-2.391c-0.286-0.33-0.622-0.32-0.86-0.254c-0.324,0.093-0.683,0.381-0.749,0.812   c-0.097,0.63,0.447,1.388,1.492,2.081c0.422,0.278,0.536,0.846,0.258,1.267C224.657,260.094,224.367,260.24,224.07,260.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M248.603,260.24c-0.296,0-0.587-0.145-0.762-0.408c-0.278-0.422-0.163-0.989,0.258-1.267   c1.045-0.693,1.589-1.451,1.492-2.081c-0.067-0.431-0.425-0.719-0.749-0.812c-0.238-0.066-0.575-0.077-0.86,0.254   c-2.662,3.095-5.026,2.827-6.2,2.391c-1.608-0.596-2.774-2.19-2.774-3.787c0-0.505,0.408-0.914,0.914-0.914   c0.505,0,0.914,0.408,0.914,0.914c0,0.73,0.591,1.706,1.582,2.074c1.252,0.465,2.74-0.196,4.179-1.87   c0.693-0.809,1.719-1.11,2.746-0.819c1.08,0.309,1.887,1.208,2.054,2.292c0.124,0.801-0.009,2.374-2.29,3.884   C248.952,260.189,248.776,260.24,248.603,260.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M223.567,261.324c-0.193,0-0.387-0.061-0.553-0.185c-0.402-0.307-0.479-0.879-0.174-1.281   l19.864-26.119c0.19-0.343,0.262-0.818,0.344-1.365c0.153-1.026,0.345-2.303,1.911-3.245c1.021-0.612,2.232-0.595,3.245,0.052   c1.118,0.714,1.777,2.044,1.641,3.309c-0.082,0.769-0.531,2.172-2.612,2.943c-0.476,0.177-1-0.067-1.174-0.538   c-0.175-0.473,0.066-1,0.538-1.174c0.607-0.225,1.348-0.655,1.43-1.425c0.063-0.584-0.269-1.229-0.808-1.575   c-0.301-0.193-0.774-0.358-1.319-0.025c-0.829,0.498-0.911,1.044-1.047,1.949c-0.096,0.641-0.205,1.367-0.633,2.106l-19.927,26.213   C224.116,261.2,223.843,261.324,223.567,261.324z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "236.408,232.596 227.27,243.562 230.925,254.528 241.891,254.528 245.546,243.562  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.408,231.168l-10.166,12.199l4.024,12.074h12.282l4.024-12.074L236.408,231.168z   M228.297,243.756l7.197-8.636v18.493h-3.911L228.297,243.756z M241.232,253.614h-3.911v-18.493l7.197,8.636L241.232,253.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M284.561,277.841l0.138-2.027c0,0,1.798-1.29,0.921-2.488c-0.875-1.198-1.889-1.429-4.009-1.152  c-2.12,0.277-5.438,0.231-6.866,0.322c-1.429,0.093-2.166,0.875-4.424,0.231l0.599-1.383c0,0-1.059,0.093-1.705,0.415  c-0.352,0.177-1.198-0.968-2.027-0.783c-0.826,0.183-1.658,1.889-2.95,2.765l0.691,1.383c0,0,0.783-0.369,1.383,0.046  c0.599,0.415,0.783,0.691,1.798,0.691l0.646,0.277c0,0-0.231,1.474,0.737,2.166c0,0-1.106,1.429-0.968,1.658  c0.138,0.231,1.059,1.982,1.429,2.995l0.83-1.567c0,0-1.245-1.106-1.014-1.245c0.231-0.138,1.059-0.322,0.921-0.691  s0.646,0.046,1.521,0.184c0,0,0.046,1.383,0.231,1.567s0.461,0.921,0.415,1.705c-0.046,0.783-0.737,1.014-0.737,1.014l1.245,0.369  c0,0,0.322-0.461,0.553-0.415c0,0-0.093-3.825,0.415-4.424c0,0,2.995,0.599,4.377-0.138c0,0,0.177,0.223,0.522,0.435  c-0.138,0.321-0.255,0.641-0.203,0.735c0.116,0.209,0.486,0.185,0.578-0.046c0.035-0.087,0.089-0.266,0.143-0.451  c0.167,0.055,0.35,0.098,0.559,0.119c-0.02,0.291-0.022,0.559,0.045,0.621c0.174,0.161,0.519,0.024,0.535-0.225  c0.006-0.081,0.002-0.234-0.002-0.398c0.238-0.02,0.492-0.062,0.772-0.145l-1.567,2.581l-0.783,0.322l1.014,0.507l0.921-0.369  c0,0,0.875-2.212,2.304-2.857c0,0,0.968,2.304-0.231,3.549l1.059,0.599l0.507-1.06c0,0-0.184-2.073,0.507-3.41L284.561,277.841z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M267.208,271.255c0,0-0.462-0.439-0.578-1.017s-0.255-0.833-0.764-0.994c0,0,0.323,0.37,0.278,0.948   c-0.046,0.578,0,1.365,0.323,1.619L267.208,271.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M271.233,272.886c0,0-0.629,2.138-2.477,3.25l-0.644-0.277c0,0,1.973-1.686,2.212-3.134   L271.233,272.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.087,271.764c-0.066-0.068,0.81-0.323,0.601-1.017c-0.209-0.694-0.209-1.203,0.209-1.526   c0,0,0.046,0.578,0.37,0.948c0.323,0.37,0.509,1.295-0.023,1.827C269.244,271.996,268.711,272.412,268.087,271.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.187,278.07L268.187,278.07c-0.11-0.054-0.157-0.189-0.102-0.299l0.279-0.568   c0.163-0.333,0.055-0.747-0.266-0.932c-0.353-0.203-0.797-0.063-0.973,0.296l-0.29,0.59c-0.054,0.11-0.189,0.157-0.299,0.102   l-0.174,0.354c0,0,0.256,0.126,0.566,0.278l-0.007,0.013c-0.071,0.143-0.011,0.317,0.132,0.387   c0.143,0.071,0.317,0.011,0.387-0.132l0.007-0.013c0.31,0.152,0.566,0.278,0.566,0.278L268.187,278.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "270.424,281.964 271.117,282.103 270.538,283.884 269.954,282.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "272.12,283.923 271.696,284.671 273.361,284.671 273.364,284.292  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "280.322,283.37 280.322,283.815 278.432,283.815 279.346,282.901  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "283.317,283.692 282.384,284.627 284.348,284.627 284.377,284.292  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M284.561,292.279l0.138-2.027c0,0,1.798-1.29,0.921-2.488c-0.875-1.198-1.889-1.429-4.009-1.152  c-2.12,0.277-5.438,0.231-6.866,0.322c-1.429,0.093-2.166,0.875-4.424,0.231l0.599-1.383c0,0-1.059,0.093-1.705,0.415  c-0.352,0.177-1.198-0.968-2.027-0.783c-0.826,0.183-1.658,1.889-2.95,2.765l0.691,1.383c0,0,0.783-0.369,1.383,0.046  c0.599,0.415,0.783,0.691,1.798,0.691l0.646,0.277c0,0-0.231,1.474,0.737,2.166c0,0-1.106,1.429-0.968,1.658  c0.138,0.231,1.059,1.982,1.429,2.995l0.83-1.567c0,0-1.245-1.106-1.014-1.245c0.231-0.138,1.059-0.322,0.921-0.691  c-0.138-0.369,0.646,0.046,1.521,0.184c0,0,0.046,1.383,0.231,1.567s0.461,0.921,0.415,1.705c-0.046,0.783-0.737,1.014-0.737,1.014  l1.245,0.369c0,0,0.322-0.461,0.553-0.415c0,0-0.093-3.825,0.415-4.424c0,0,2.995,0.599,4.377-0.138c0,0,0.177,0.223,0.522,0.435  c-0.138,0.321-0.255,0.641-0.203,0.735c0.116,0.209,0.486,0.185,0.578-0.046c0.035-0.087,0.089-0.266,0.143-0.451  c0.167,0.055,0.35,0.098,0.559,0.119c-0.02,0.291-0.022,0.559,0.045,0.621c0.174,0.161,0.519,0.024,0.535-0.225  c0.006-0.081,0.002-0.234-0.002-0.398c0.238-0.02,0.492-0.062,0.772-0.145l-1.567,2.581l-0.783,0.322l1.014,0.507l0.921-0.369  c0,0,0.875-2.212,2.304-2.857c0,0,0.968,2.304-0.231,3.549l1.059,0.599l0.507-1.06c0,0-0.184-2.073,0.507-3.41L284.561,292.279z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M267.208,285.694c0,0-0.462-0.439-0.578-1.017s-0.255-0.833-0.764-0.994c0,0,0.323,0.37,0.278,0.948   c-0.046,0.578,0,1.365,0.323,1.619L267.208,285.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M271.233,287.325c0,0-0.629,2.138-2.477,3.25l-0.646-0.277c0,0,1.973-1.686,2.212-3.134   L271.233,287.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.087,286.203c-0.066-0.068,0.81-0.323,0.601-1.017c-0.209-0.694-0.209-1.203,0.209-1.526   c0,0,0.046,0.578,0.37,0.948c0.323,0.37,0.509,1.295-0.023,1.827C269.244,286.435,268.711,286.85,268.087,286.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.187,292.509L268.187,292.509c-0.11-0.054-0.157-0.189-0.102-0.299l0.279-0.568   c0.163-0.333,0.055-0.747-0.266-0.932c-0.353-0.203-0.797-0.063-0.973,0.296l-0.29,0.59c-0.054,0.11-0.189,0.157-0.299,0.102   l-0.174,0.354c0,0,0.256,0.126,0.566,0.278l-0.007,0.013c-0.071,0.143-0.011,0.317,0.132,0.387   c0.143,0.071,0.317,0.011,0.387-0.132l0.007-0.013c0.31,0.152,0.566,0.278,0.566,0.278L268.187,292.509z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "270.424,296.403 271.117,296.542 270.538,298.323 269.954,297.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "272.12,298.362 271.696,299.11 273.361,299.11 273.364,298.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "280.322,297.809 280.322,298.254 278.432,298.254 279.346,297.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "283.317,298.131 282.384,299.066 284.348,299.066 284.377,298.73  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.0675d1c101efa5467528ee58d07983f3.svg";
export { ForwardRef as ReactComponent };